import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiState } from '../../../types/api';
import { RootState } from '../..';
import {
  IThresholdsApiResponse,
  ITransactionThreshold,
} from './transactionThresholdsTypes';

const initialState: IApiState<
  IThresholdsApiResponse<ITransactionThreshold[]>
> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getTransactionThresholdsAsync = createAsyncThunk(
  'business-settings/2fa-thresholds/get',
  async (_: void, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const accessToken = state.auth.value?.data?.token?.accessToken;
      const businessId =
        localStorage.getItem('businessId') ||
        state.auth.value?.data?.user?.businesses?.[0]?.id;

      const { data } = await api.get<
        IThresholdsApiResponse<ITransactionThreshold[]>
      >('/business-settings/2fa-thresholds', {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      });

      return data;
    } catch (err) {
      const error = err as AxiosError<
        IThresholdsApiResponse<ITransactionThreshold[]>
      >;
      return rejectWithValue(error.response?.data);
    }
  },
);

export const getTransactionThresholdsSlice = createSlice({
  name: 'business-settings/2fa-thresholds/get',
  initialState,
  reducers: {
    resetTransactionThresholds: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTransactionThresholdsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getTransactionThresholdsAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload;
      })
      .addCase(getTransactionThresholdsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IThresholdsApiResponse<
          ITransactionThreshold[]
        >;
        state.error = action.error.message;
      });
  },
});

export const { resetTransactionThresholds } =
  getTransactionThresholdsSlice.actions;

export default getTransactionThresholdsSlice.reducer;
